/*
 * Off-Season program signup controller (AAC, issue #109).
 * One-time purchase, one page: primary athlete + parent fields + inline "add sibling" repeater + live total,
 * submitted as a multi-line /cart/add (base line + one $19.99 sibling line per sibling, each with its own
 * name/age properties). No selling plan (one-time). No framework; self-running + idempotent.
 */
(function () {
  function money(cents) {
    return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function init(root) {
    if (!root || root.__skOsBound) return;
    root.__skOsBound = true;

    var cfgEl = root.querySelector('[data-sk-os-config]');
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

    var sibling = cfg.sibling; // { variantId, price, priceText } or null
    var rowsEl = root.querySelector('[data-sk-os-rows]');
    var addBtn = root.querySelector('[data-sk-os-add]');
    var totalEl = root.querySelector('[data-sk-os-total]');
    var submitEl = root.querySelector('[data-sk-os-submit]');
    var errorEl = root.querySelector('[data-sk-os-error]');
    var primaryInputs = Array.prototype.slice.call(root.querySelectorAll('[data-os-prop]'));

    var rows = []; // { name, age }

    function recalc() {
      var cents = cfg.basePrice;
      if (sibling) cents += rows.length * sibling.price;
      if (totalEl) totalEl.textContent = money(cents);
    }

    function renderRows() {
      if (!rowsEl) return;
      rowsEl.innerHTML = '';
      rows.forEach(function (r, i) {
        var row = document.createElement('div');
        row.className = 'sk-os__row';

        var head = document.createElement('div');
        head.className = 'sk-os__row-head';

        var label = document.createElement('span');
        label.className = 'sk-os__row-label';
        label.textContent = 'Sibling ' + (i + 1);

        var price = document.createElement('span');
        price.className = 'sk-os__row-price';
        price.textContent = '+' + (sibling ? sibling.priceText : '');

        var remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'sk-os__row-remove';
        remove.setAttribute('aria-label', 'Remove sibling ' + (i + 1));
        remove.innerHTML = '&times;';
        remove.addEventListener('click', function () { rows.splice(i, 1); renderRows(); recalc(); });

        head.appendChild(label);
        head.appendChild(price);
        head.appendChild(remove);

        var fields = document.createElement('div');
        fields.className = 'sk-os__row-fields';

        var nameInput = document.createElement('input');
        nameInput.type = 'text';
        nameInput.className = 'sk-os__input';
        nameInput.placeholder = 'Sibling full name';
        nameInput.autocomplete = 'name';
        nameInput.value = r.name || '';
        nameInput.addEventListener('input', function () { r.name = nameInput.value; });

        var ageInput = document.createElement('input');
        ageInput.type = 'number';
        ageInput.className = 'sk-os__input sk-os__input--age';
        ageInput.placeholder = 'Age';
        ageInput.min = '8';
        ageInput.max = '19';
        ageInput.inputMode = 'numeric';
        ageInput.value = r.age || '';
        ageInput.addEventListener('input', function () { r.age = ageInput.value; });

        fields.appendChild(nameInput);
        fields.appendChild(ageInput);

        row.appendChild(head);
        row.appendChild(fields);
        rowsEl.appendChild(row);
      });
      recalc();
    }

    if (addBtn && sibling) {
      addBtn.addEventListener('click', function () { rows.push({ name: '', age: '' }); renderRows(); });
    }

    function showError(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg;
      errorEl.hidden = !msg;
    }

    function submit() {
      showError('');

      // Primary athlete + parent — gather props, validate required.
      var baseProps = { Program: cfg.program };
      for (var i = 0; i < primaryInputs.length; i++) {
        var el = primaryInputs[i];
        var val = (el.value || '').trim();
        if (el.hasAttribute('data-os-required') && !val) {
          showError('Please fill in all athlete & parent fields.');
          el.focus();
          return;
        }
        if (val) baseProps[el.getAttribute('data-os-prop')] = val;
      }

      // Siblings — each needs name + age.
      for (var j = 0; j < rows.length; j++) {
        if (!(rows[j].name || '').trim() || !(rows[j].age || '').trim()) {
          showError('Please enter a name and age for each sibling (or remove the empty one).');
          return;
        }
      }

      var items = [{ id: cfg.mainVariantId, quantity: 1, properties: baseProps }];
      if (sibling) {
        rows.forEach(function (r) {
          items.push({
            id: sibling.variantId,
            quantity: 1,
            properties: {
              'Sibling Name': r.name.trim(),
              'Sibling Age': r.age.trim(),
              'Parent / Guardian Name': baseProps['Parent / Guardian Name'] || '',
              Program: cfg.program
            }
          });
        });
      }

      submitEl.disabled = true;
      submitEl.textContent = 'Adding…';
      fetch(root.getAttribute('data-cart-add'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) { return res.json().then(function (b) { return { ok: res.ok, body: b }; }); })
        .then(function (r) {
          if (!r.ok) {
            showError((r.body && r.body.description) || 'Could not add to cart. Please try again.');
            submitEl.disabled = false;
            submitEl.textContent = 'Add to Cart';
            return;
          }
          window.location.href = root.getAttribute('data-cart-url') || '/cart';
        })
        .catch(function () {
          showError('Network error. Please try again.');
          submitEl.disabled = false;
          submitEl.textContent = 'Add to Cart';
        });
    }

    if (submitEl) submitEl.addEventListener('click', submit);
    recalc();
  }

  function boot() {
    document.querySelectorAll('[data-sk-os]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
